export default __webpack_public_path__ + "static/media/arrowLeft.82cac18c.svg";